import React from 'react';
import {
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem } from 'reactstrap';
import logo from '../assets/images/logo.png'
import { Link } from 'react-router-dom';


export default class Example extends React.Component {
    constructor(props) {
        super(props);
    
        this.toggle = this.toggle.bind(this);
        this.toggleDrop = this.toggleDrop.bind(this);
        // this.onMouseEnter = this.onMouseEnter.bind(this);
        // this.onMouseLeave = this.onMouseLeave.bind(this);
        this.toggleDropAbout = this.toggleDropAbout.bind(this);
        this.toggleDropCareers = this.toggleDropCareers.bind(this);
        this.toggleDropLogin = this.toggleDropLogin.bind(this);
        // this.onMouseEnterAbout = this.onMouseEnterAbout.bind(this);
        // this.onMouseLeaveAbout = this.onMouseLeaveAbout.bind(this);
        this.handleTextChange = this.handleTextChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.toggleSearch = this.toggleSearch.bind(this);
        this.state = {
          isOpen: false,
          dropdownOpen: false,
          dropdownOpenAbout: false,
          dropdownCareers: false,
          dropdownOpenLogin: false,
          query: '',
          searchOpen: false,
          clicked: false
        };
    }
    
    handleTextChange = (e) => {
      this.setState({
        [e.target.id]: e.target.value
      })
    }
    handleSubmit = (e) => {
      e.prevetDefault();
    }
    toggleSearch() {
      this.setState({
        searchOpen: !this.state.searchOpen
      });
    }
    toggle() {
        this.setState({
          isOpen: !this.state.isOpen
        });
    }
    toggleDrop() {
      this.setState(prevState => ({
        dropdownOpen: !prevState.dropdownOpen
      }));
      (this.state.clicked) ? document.getElementById('serv').classList.remove('wehove') : document.getElementById('serv').classList.add('wehove');
      document.getElementById('aobtu').classList.remove('wehove');
      document.getElementById('career').classList.remove('wehove');
      document.getElementById('login').classList.remove('wehove');
    }
    // onMouseEnter() {
    //   this.setState({dropdownOpen: true});
    //   document.getElementById('serv').classList.add('wehove');
    // }
  
    // onMouseLeave() {
    //   this.setState({dropdownOpen: false});
    //   document.getElementById('serv').classList.remove('wehove');
    // }

    toggleDropAbout() {
      this.setState(prevState => ({
        dropdownOpenAbout: !prevState.dropdownOpenAbout,
        clicked: !prevState.clicked
      }));
      (this.state.clicked) ? document.getElementById('aobtu').classList.remove('wehove') : document.getElementById('aobtu').classList.add('wehove');
      document.getElementById('serv').classList.remove('wehove');
      document.getElementById('career').classList.remove('wehove');
      document.getElementById('login').classList.remove('wehove');
    }
    toggleDropLogin() {
      this.setState(prevState => ({
        dropdownOpenLogin: !prevState.dropdownOpenLogin,
        clicked: !prevState.clicked
      }));
      (this.state.clicked) ? document.getElementById('login').classList.remove('wehove') : document.getElementById('login').classList.add('wehove');
      document.getElementById('serv').classList.remove('wehove');
      document.getElementById('career').classList.remove('wehove');
      document.getElementById('aobtu').classList.remove('wehove');
    }
    toggleDropCareers() {
      this.setState(prevState => ({
        dropdownCareers: !prevState.dropdownCareers,
        clicked: !prevState.clicked
      }));
      (this.state.clicked) ? document.getElementById('career').classList.remove('wehove') : document.getElementById('career').classList.add('wehove');
      document.getElementById('serv').classList.remove('wehove');
      document.getElementById('aobtu').classList.remove('wehove');
      document.getElementById('login').classList.remove('wehove');
    }

    // onMouseEnterAbout() {
    //   this.setState({dropdownOpenAbout: true});
    //   document.getElementById('aobtu').classList.add('wehove');
    // }
  
    // onMouseLeaveAbout() {
    //   this.setState({dropdownOpenAbout: false});
    //   document.getElementById('aobtu').classList.remove('wehove');
    // }
  
    render() {
        return (
          <div className="container-fluid navigation">
            <Navbar color="light" light expand="md" >
              <NavbarBrand href="/">
                  <img src={logo} alt='lo go'/>
              </NavbarBrand>
              <NavbarToggler onClick={this.toggle} />
              <Collapse isOpen={this.state.isOpen} navbar>
                <Nav className="ml-auto" navbar>
                <UncontrolledDropdown nav inNavbar isOpen={this.state.dropdownOpenAbout} toggle={this.toggleDropAbout}> 
                    <DropdownToggle  tag="a" className='nav-none nav-link' caret id='aobtu'>
                      Our Bank
                    </DropdownToggle>
                    <DropdownMenu right>
                      <DropdownItem>
                        <NavLink href="/about">Who We Are</NavLink>
                      </DropdownItem>
                      <DropdownItem>
                        <NavLink href="/productlist/gMarkets">Products</NavLink>
                      </DropdownItem>
                      <DropdownItem>
                        <NavLink href="/resources/media">Insight</NavLink>
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                  {/* <NavItem>
                    <NavLink href="/services">Services</NavLink>
                  </NavItem> */}
                   <UncontrolledDropdown nav inNavbar isOpen={this.state.dropdownOpen} toggle={this.toggleDrop}> 
                    <DropdownToggle nav tag="a" className='nav-none nav-link' caret id="serv">
                      Services
                    </DropdownToggle>
                    <DropdownMenu right>
                      <DropdownItem>
                        <NavLink href="/servicelist/cManagement">Cash Management</NavLink>
                      </DropdownItem>
                      <DropdownItem>
                        <NavLink href="/servicelist/wManagement">Wealth Management</NavLink>
                      </DropdownItem>
                      <DropdownItem>
                        <NavLink href="/servicelist/rManagement">Risk Management</NavLink>
                      </DropdownItem>
                      <DropdownItem>
                        <NavLink href="/servicelist/financing">Financing</NavLink>
                      </DropdownItem>
                      <DropdownItem>
                        <NavLink href="/servicelist/advisory">Advisory</NavLink>
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                  <UncontrolledDropdown nav inNavbar isOpen={this.state.dropdownCareers} toggle={this.toggleDropCareers}> 
                    <DropdownToggle nav tag="a" className='nav-none nav-link' caret id="career">
                      Careers
                    </DropdownToggle>
                    <DropdownMenu right>
                      <DropdownItem>
                        <NavLink href="/culture">Our Culture</NavLink>
                      </DropdownItem>
                      <DropdownItem>
                        <NavLink href="/careers">Vacancies</NavLink>
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                  <NavItem>
                    <NavLink href="/research">Research</NavLink>
                  </NavItem>
                  <UncontrolledDropdown nav inNavbar isOpen={this.state.dropdownOpenLogin} toggle={this.toggleDropLogin}> 
                    <DropdownToggle nav tag="a" className='nav-none nav-link' caret id="login">
                      Online Banking Login
                    </DropdownToggle>
                    <DropdownMenu right>
                      <DropdownItem>
                        <NavLink href="https://fsdhonline.fsdhgroup.com/root/login">Login</NavLink>
                      </DropdownItem>
                      <DropdownItem>
                        <NavLink href="https://signup.fsdhgroup.com/sysworkflow/en/neoclassic/8440068405d3067f64b4a65096377043/5353824985d306986c6af43042703129.php">Open an Account</NavLink>
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </Nav>
              </Collapse>

              {(this.state.searchOpen) ?
                <div>
                  <form onSubmit={this.handleSubmit}>
                    <div className="form-inline float-md-right">
                        <input type='search' placeholder="Enter Search" value={this.state.query} onChange={this.handleTextChange} id='query' />
                        <Link to={{ pathname: "/search", search: "?result="+this.state.query }}><button type='submit'></button> </Link>
                    </div>
                  </form>
                </div>
              : null}

              <div className="navSearch">
                  <button type='submit' onClick={this.toggleSearch}>
                    {/* <i className="fa fa-caret-right" aria-hidden="true"></i> */}
                    <i className="fa" aria-hidden="true"></i>
                  </button>
              </div>

            </Navbar>
          </div>
        );
      }
    }